import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_find_ordersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lookupCode?: string, owner?: string, project?: string, ownerReference?: string, vendorReference?: string, warehouse?: string, status?: string, modifiedFrom?: string, modifiedTo?: string, orderTypeId?: number, shippedFrom?: string, shippedTo?: string, orderClass?: string, excludeTransmitted?: boolean }): 
  Promise<{ result: { Id?: number, FulfillmentDate?: string, LookupCode?: string, ModifiedSysDateTime?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, PreferredWarehouse?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string }, OrderClass?: { Id?: number, LookupCode?: string, Name?: string, OrderType?: { Id?: number, Name?: string } }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, ShippedDate?: string, Status?: { Id?: number, Name?: string } } }[], WavelengthConnectorOrderTransmissions?: { IntegrationId?: string, TransactionId?: string }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_find_orders/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lookupCode?: string, owner?: string, project?: string, ownerReference?: string, vendorReference?: string, warehouse?: string, status?: string, modifiedFrom?: string, modifiedTo?: string, orderTypeId?: number, shippedFrom?: string, shippedTo?: string, orderClass?: string, excludeTransmitted?: boolean, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, FulfillmentDate?: string, LookupCode?: string, ModifiedSysDateTime?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, PreferredWarehouse?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string }, OrderClass?: { Id?: number, LookupCode?: string, Name?: string, OrderType?: { Id?: number, Name?: string } }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, ShippedDate?: string, Status?: { Id?: number, Name?: string } } }[], WavelengthConnectorOrderTransmissions?: { IntegrationId?: string, TransactionId?: string }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_find_orders/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lookupCode?: string, owner?: string, project?: string, ownerReference?: string, vendorReference?: string, warehouse?: string, status?: string, modifiedFrom?: string, modifiedTo?: string, orderTypeId?: number, shippedFrom?: string, shippedTo?: string, orderClass?: string, excludeTransmitted?: boolean, $keys: number[] }): 
  Promise<{ result: { Id?: number, FulfillmentDate?: string, LookupCode?: string, ModifiedSysDateTime?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, PreferredWarehouse?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string }, OrderClass?: { Id?: number, LookupCode?: string, Name?: string, OrderType?: { Id?: number, Name?: string } }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, ShippedDate?: string, Status?: { Id?: number, Name?: string } } }[], WavelengthConnectorOrderTransmissions?: { IntegrationId?: string, TransactionId?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_find_orders/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

